const { customerId, storeName, apiUrl } = window.fetchHookData

const originalFetch = window.fetch

let applyingDiscounts = false

const applyDiscounts = async () => {
  if (applyingDiscounts) {
    console.log('already calling discounts apply, wait for end')
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (applyingDiscounts === false) {
          clearInterval(interval)
          resolve()
        }
      }, 100)
    })
  }
  applyingDiscounts = true
  console.log('apply discounts')
  const cartResponse = await originalFetch('/cart.js')
  const cart = await cartResponse.json()
  const cartId = cart.token

  console.log({ cart })

  await originalFetch(`${apiUrl}/apply-discount`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      cartId,
      customerId,
      storeName,
    }),
  })

  document.dispatchEvent(new CustomEvent('cart:refresh'))
  applyingDiscounts = false
}

const fetchHook = () => {
  console.info({ customerId, storeName, apiUrl })
  if (!customerId || !storeName || !apiUrl) {
    return
  }

  console.info('installing fetch hook')

  window.fetch = async function (input, init) {
    console.log('exec hook')
    if (
      typeof input === 'string' &&
      input.startsWith('/cart') &&
      init?.method?.toUpperCase() === 'POST' &&
      !input.includes('shipping_rates')
    ) {
      console.info('Cart update detected')
      console.log(JSON.stringify({ input, init }))
      const data = await originalFetch.apply(this, arguments)
      console.log({ data })
      await applyDiscounts()
      return data
    }
    console.log('original fetch unmodified')
    return originalFetch.apply(this, arguments)
  }
}

fetchHook()
